import { fg } from '@atlassian/jira-feature-gating';

export const csmNativeAssetsFieldCustomerContextRelayprovider = {
	get(): boolean {
		return fg('csm_native_assets_field_customer_context');
	},
};

export default csmNativeAssetsFieldCustomerContextRelayprovider;
